import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { object } from "yup";
import PURCHASEIRQLoanOptionsView from "../views/IrqLoanOptionsView";
import StatusCheck from "../components/StatusCheck";

class BuildIrqLoanOptionsPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="buildIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object()}
        >
          <PURCHASEIRQLoanOptionsView
            content={contentMap.BuildIrqLoanOptionsPage}
            navigationsAway={customNavigationMap.BuildIrqLoanOptionsPage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(BuildIrqLoanOptionsPage);
